import { userStore } from '~/stores/UserStore';
import { getCookieLang } from '~/utils/cookies';

export const getLangHeaders = (serverLang?: string) => ({
  headers: { 'x-lang': serverLang || getCookieLang() || userStore.lang || '' },
});
